export const handleCustomChange = (index, e, stateArray, setStateArray) => {
  const { name, value } = e.target;
  const updated = [...stateArray];
  updated[index][name] = value;
  setStateArray(updated);
};

export const validateFields = (fields, requiredFields) => {
  const errors = {};
  requiredFields.forEach((field) => {
    if (!fields[field] || fields[field].trim() === '') {
      errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    }
  });
  return errors;
};

export const handleAddRow = ({ list, setList, requiredFields = [], defaultItem, setErrors,}) => {
  const last = list[list.length - 1];
  const errors = validateFields(last, requiredFields);

  if (Object.keys(errors).length > 0) {
    setErrors(errors);
    return false;
  }

  setErrors({});
  const updatedList = list.map((item, index) =>
    index === list.length - 1 ? { ...item, readonly: true } : item
  );
  setList([...updatedList, { ...defaultItem, readonly: false }]);
  return true;
};

export const toggleEditRow = (index, list, setList) => {
  const updatedList = [...list];
  updatedList[index].readonly = !updatedList[index].readonly;
  setList(updatedList);
};

export const deleteRow = (index, list, setList) => {
  const updatedList = [...list];
  updatedList.splice(index, 1);
  setList(updatedList);
};



//export default handleCustomChange;